export function getStateKeyList<StateType>(state: StateType) {
	return Object.keys(state) as Array<keyof StateType>;
}
